import { createSlice } from "@reduxjs/toolkit";
import socketFactory from "../../../../utils/socketFactory.js"
const initialState = {
    isSuperSpeakerActive: false,
};

const AnnouncementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    setIsSuperSpeakerActive: (state, action) => {
        state.isSuperSpeakerActive = action.payload;
    }
  },
});

export const {
  setIsSuperSpeakerActive,
} = AnnouncementSlice.actions;

export const makeAnnouncement = socketFactory.emit('makeAnnouncement', 'socket/makeAnnouncement');
export const stopannouncement = socketFactory.emit('stopannouncement', 'socket/stopannouncement');


export default AnnouncementSlice.reducer;